import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class HttpClientSecured {
  constructor(private http: HttpClient) {}

  get<T>(url) {
    console.log('call GET on HttpClientSecured');
    const httpOptions = {
      headers: new HttpHeaders({
        sessionToken: localStorage.getItem('sessionToken') != null ? localStorage.getItem('sessionToken') : ''
      })
    };
    return this.http.get<T>(url, httpOptions);
  }

  post<T>(url, data) {
    console.log('call POST on HttpClientSecured');
    const httpOptions = {
      headers: new HttpHeaders({
        sessionToken: localStorage.getItem('sessionToken') != null ? localStorage.getItem('sessionToken') : ''
      })
    };
    return this.http.post<T>(url, data, httpOptions);
  }

  put<T>(url, data) {
    console.log('call PUT on HttpClientSecured');
    const httpOptions = {
      headers: new HttpHeaders({
        sessionToken: localStorage.getItem('sessionToken') != null ? localStorage.getItem('sessionToken') : ''
      })
    };
    return this.http.put<T>(url, data, httpOptions);
  }
}
